<template>
  <div class="terms-condition-component">
    <div class="section-2">
      <el-row>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>

        <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
          <div class="">
            <!-- <h1>Use</h1> -->
            <p>
              Techvest LLP bearing registration No. AAR 3724 (hereinafter
              referred as ‘StockAnts’) is a marketplace where the price
              estimates are published by SEBI Registered Experts (Research
              Analyst (RA) & Registered Investment Advisor(RIA))
            </p>
            <p>
              For the purpose of these terms (Terms and Conditions), “StockAnts”
              includes the partners, the employees, representatives, agents and
              associates.
            </p>

            <p>
              StockAnts is not registered with SEBI or any other regulator in
              any capacity, except with the Ministry of Corporate Affairs as a
              limited liability partnership.
            </p>
            <p>
              User means and includes a visitor on the website
              www.stockants.com, sub domains / microsites (collectively known as
              the Website) and the mobile application, a user of the services of
              StockAnts and an Expert.
            </p>
          </div>

          <div class="special-sec">
            <h1>Terms and Conditions</h1>

            <p>
              These Terms and Conditions mandate the terms on which the user
              accesses and registers on the Website and mobile app.
            </p>
            <p>
              The users are advised to read these terms and conditions before
              using the website or availing any services from the StockAnts. In
              case of any queries with regards to the functioning of the website
              they can contact admin@stockants.com
            </p>
            <p>
              By visiting the Website or downloading, you agree to be bound by
              these terms and conditions.
            </p>
          </div>

          <div class="special-sec">
            <h1>Registration</h1>

            <ul>
              <li>
                On registering with StockAnts, you agree that all the
                information provided by you now or in the future are true and
                correct.
              </li>
            </ul>
          </div>

          <div class="special-sec">
            <h1>Use of platform</h1>

            <p>
              Subject to these terms, StockAnts hereby grants you the permission
              to use and access this website and platform, on the condition
              that:
            </p>

            <ul>
              <li>
                You agree that you will not copy, reproduce, sell, redistribute,
                display, modify, enter into any database, alter, create
                derivative, transfer or in any way exploit any part of any
                information, content, material or any piece of information
                available through the Website.
              </li>
              <li>
                You should not impersonate or misrepresent yourself as another
                person (including celebrities) entity or other user or employee
                or representative of StockAnts.
              </li>
              <li>
                On signing up with StockAnts you are granting us the permission
                to use all and any version of the logo used by you, the
                community that you have created, including but not limiting to
                names, trademark, service marks or logos for the purpose of
                marketing and promotional activities.
              </li>
              <li>
                You agree that you will not use the platform in manner or
                conduct yourself in any way which can violate the legal rights
                of others and hamper their use of the platform.
              </li>
              <li>
                Any trade executed using the price estimates published by SEBI
                Registered Experts on the website is the responsibility of the
                user and no liability shall be imposed on StockAnts.
              </li>
              <li>
                The push notifications play an important role for working on the
                platform, but any notification or alert you receive on price
                estimates given by any Expert that you have followed at your
                discretion and for your own benefit, any information rendered
                through such medium should not be considered investment advice
                or recommendation from StockAnts. In case of any loss or damage
                incurred to the user, StockAnts will not be responsible and held
                liable.
              </li>
              <li>
                The price estimates, returns, and any other data mentioned on
                the website are derived from various third party data vendors.
                The data has not been validated by the StockAnts.
              </li>
              <li>
                The price estimates and all the algorithms used on the Website
                and mobile app are arrived at based on the internal codes and
                processes of StockAnts and may be changed at any time as per the
                discretion of StockAnts.
              </li>
              <li>
                The User warrants that he/she/it shall obtain independent
                investment advice before making any Investment based on such
                price data published on StockAnts.
              </li>
              <li>
                The recommendations / views / reports / price estimates and
                other contents, including third party content, are provided on
                an "As Is" basis by StockAnts. Use of the Website and the
                content is at any User’s own risk and StockAnts will not be
                liable and responsible in any manner.
              </li>
              <li>
                Information herein is believed to be reliable but StockAnts does
                not warrant its completeness or accuracy and shall not be
                responsible or liable for any losses incurred by a user for
                acting based on the views expressed herein.
              </li>
              <li>
                StockAnts expressly disclaims all warranties and conditions of
                any kind, whether express, implied or statutory pertaining to
                the services provided by it including but not limited to implied
                warranties and conditions of merchantability, fitness for a
                particular purpose, data accuracy and completeness and any
                warranties relating to viruses and services free from disruption
                or interruption.
              </li>
              <li>
                Users should note that investments in stock markets are risky
                and should consult an investment adviser before investing or
                trading based on the recommendations given by Experts on
                StockAnts.
              </li>
              <li>
                User shall bear all responsibility of keeping the password
                secure and in the event that the User incurs any liability to
                StockAnts or any other third party as a result of the password
                being used by third parties, or due to improper use of the
                password, User shall, without limitation, bear all such
                liability. Notwithstanding anything contained herein, in the
                event any liability arising to the User as a consequence of any
                of StockAnts' employees accessing the User's password without
                authorization shall be borne by the User.
              </li>
              <li>
                Market prices and price estimates shown on the Website or mobile
                application may be delayed and StockAnts will not be liable or
                responsible for loss or liability arising to the user on account
                of the delay.
              </li>
              <li>
                Past performance does not guarantee future performance or
                returns.
              </li>
            </ul>
            <h1>Under Indian Judiciary</h1>
            <p>
              This Agreement entered into and the relationship between you and
              the Company shall be governed in accordance with the laws of India
              without reference to any conflict of laws principles.
            </p>
          </div>

          <div class="special-sec">
            <h1>Platform services</h1>
            <ul>
              <li>
                The Experts listed on the website are SEBI registered Experts
                (Research Analyst & Registered Investment Advisor
              </li>
              <li>
                The price estimates are just reference for the users following
                the Experts. In case the user needs more detailed research/
                recommendations/ views the users are advised to reach the
                Experts website or mobile application if any.
              </li>
              <li>
                StockAnts reserves the right to discontinue, whether on a
                temporary or permanent basis, any of the features available on
                Website and mobile application.
              </li>
            </ul>
          </div>

          <div class="special-sec">
            <h1>Modification of Terms and Conditions</h1>
            <p>
              We reserve the right to update the Terms and Conditions at any
              time, with or without notice.
            </p>
            <p>
              The continual use of Website after the update will be considered
              as deemed consent by the user, and they cannot claim any liability
              from StockAnts.
            </p>
            <p>
              You agree to review these terms of use periodically since
              subsequent use by you of this site shall constitute your
              acceptance of any changes. StockAnts shall have the right at any
              time to change or discontinue any aspect of the Website, mobile
              app, including, but not limited to, the community areas, content
              and equipment needed for access to use. Such changes,
              modifications, additions or deletions shall be effective
              immediately upon posting or updating and any subsequent use by you
              after such posting shall conclusively be deemed to be acceptance
              by you of such changes, modifications or deletions.
            </p>
          </div>

          <div class="special-sec">
            <h1>Under Indian Judiciary</h1>
            <p>
              This Agreement entered into and the relationship between you and
              StockAnts shall be governed in accordance with the laws of India
              without reference to any conflict of laws principles.
            </p>
          </div>

          <div class="special-sec">
            <h1>Limits on Personal and Non-Commercial Use:</h1>
            <p>
              The User expressly agrees to use the service strictly for personal
              purpose and at his own discretion and under no obligation to use
              the services. The User shall not recompile, disassemble, copy,
              modify, distribute, transmit, perform, reproduce, publish or
              create derivative works from, transfer, or sell any information,
              software, products, tools or services accessed from this Website.
              The User may not rent, lease, sell, sublicense, lend or in any
              manner allow any other party to use the service, with or without
              consideration. By viewing the contents of this website you agree
              with this condition of viewing and you acknowledge that any
              unauthorised use is unlawful and may subject you to civil or
              criminal penalties.
            </p>
          </div>

          <div class="special-sec">
            <h1>Indemnification</h1>

            <p>
              The User agrees to indemnify, defend and hold harmless StockAnts,
              its officers, partners, employees, associates, representatives and
              agents, any third party providers, distributors from and against
              any cause of action, claim or demand, including without limitation
              any reasonable legal accounting or other professional fees,
              brought by or on the user's behalf in excess of the liability
              described herein or by / on account of a third party due to or
              arising out of user's use of this Website and mobile app, the
              service contained herein, views expressed herein, the violation of
              any intellectual property or any other right of any person or
              entity.
            </p>
            <p>
              This clause will survive the termination or expiration of terms
              and conditions or termination of usage of the user of the website
              or mobile application.
            </p>
          </div>

          <div class="special-sec">
            <h1>Limitations of liability</h1>
            <p>
              StockAnts will not be liable to you (whether under the law of
              contact, the law of torts or otherwise) in relation to the
              contents of, or use of, or otherwise in connection with, this
              Website:
            </p>
            <ul>
              <li>
                for any direct, indirect, special or consequential loss; or
              </li>
              <li>
                for any business losses, loss of revenue, income, profits or
                anticipated savings, loss of contracts or business
                relationships, loss of reputation or goodwill, or loss or
                corruption of information or data.
              </li>
              <li>
                for any direct or indirect loss or liability incurred due to
                transactions placed on the Website or mobile app and due to any
                error or omission or interruption on any third party website or
                third party product.
              </li>
            </ul>
          </div>

          <div class="special-sec">
            <h1>Objectionable Information</h1>
            <p>
              While using the services of StockAnts, if you come across any
              content or comment that is abusive in nature or violating the
              Terms and Conditions or if you become aware of any objectionable
              content on the platform, please report the same by sending an
              email with the all the necessary details to admin@stockants.com.
            </p>
          </div>

          <div class="special-sec">
            <h1>Complaint</h1>

            <p>
              In case of any grievance with respect to the Website or the
              services, including any discrepancies with respect to processing
              of information or display of information, you can reach us
              at admin@stockants.com and inform about the same along with the
              documents and necessary action will be taken in due course.
            </p>
            <p>The decision of StockAnts will be final and binding on you.</p>
            <p>
              StockAnts will not be responsible for any dispute from third party
              products or services, including services from the broker or any
              Expert, and the same will be handled and resolved by such third
              party.
            </p>
          </div>

          <div class="special-sec">
            <h1>Unsystematic Risk</h1>

            <p>
              The information is provided by third parties and while we
              endeavour to keep the information up to date and correct, we make
              no representations or warranties of any kind, express or implied,
              about the completeness, accuracy, reliability, suitability or
              availability with respect to the website or the information,
              products, services, or related graphics contained on the website
              for any purpose. Any reliance you place on such information is
              therefore strictly at your own risk. StockAnts will not be
              responsible for any delay or failure while complying with our
              obligations under the Agreement , if the delay or failure arises
              from any cause which is beyond our control, including but not
              limited to acts of God, acts of any governmental authority, and
              any virus or security breach to StockAnts’s online facilities
              through which the Services are rendered.
            </p>
          </div>

          <div class="special-sec">
            <h1>BO Clause (Under Banking Ombudsman Regulations)</h1>

            <p>
              StockAnts shall be under no liability whatsoever in respect of any
              loss or damage arising directly or indirectly out of the decline
              of authorisation of any transaction in your account
              (Payer/Cardholder) having exceeded his pre-set limit mutually
              agreed.
            </p>
            <p>
              In an event that transactions were not reflected in your account
              StockAnts is not responsible for it and the customer should
              contact their Broker and Broking house for the same.
            </p>
          </div>
          <div class="special-sec">
            <h1>Cookies</h1>

            <p>
              Cookies are information that the browser collects after visiting a
              website. We may use cookies for technical purposes and to enhance
              the navigation and working of the website. We may also use them to
              store user preferences while interacting with our website. You
              have the option to turn off cookies on your browser but it can
              affect your browsing experience while using the platform.
            </p>
          </div>
          <div class="special-sec">
            <h1>Intellectual Property Rights(IP):</h1>

            <p>
              StockAnts hereby grants to the User, the right to use the Service
              in accordance with these terms, and for no other purpose. Please
              note that all elements contained on this Web-Site are owned by
              StockAnts and are protected by Copyright, Service Marks and
              Trademark laws, and/or other proprietary rights under the laws of
              India and these Terms of Use. The content published by the Experts
              will be owned by the Experts only. By using the service you agree
              to abide by all applicable Copyright and other laws. StockAnts or
              other third parties shall be entitled to obtain equitable relief
              for any violation of their IP, over and above all other remedies
              available to it to protect its interests therein. Copying for
              reproduction, for redistribution or other purpose of the web site,
              mobile app or any part thereof including but not limited to text
              content and graphics to any other server or location including
              caching of any kind, Decompiling, reverse engineering, or
              disassembling the content is expressly prohibited. StockAnts owns
              its applications and Trademarks.
            </p>
          </div>
          <div class="special-sec">
            <h1>Links to third Party Sites:</h1>
            <p>
              This Website and the mobile app may contain links to websites
              operated by parties other than StockAnts. The links in this
              Website will let the user leave www.stockants.com and proceed to
              the third-party website. The user's use of each such website is
              also subject to these Terms and Conditions and other terms of use,
              if any, contained within each such website. In the event that any
              of the terms contained herein conflict with the terms of use
              contained within any such websites, then the terms of use for such
              websites shall prevail. The third-party websites are not under the
              control of StockAnts and StockAnts is not responsible for the
              contents of any third-party website or any changes or updates to
              such websites. StockAnts will not directly or indirectly be liable
              for any loss that may arise to any user as a result of his
              accessing the linked sites.
            </p>
          </div>
          <div class="special-sec">
            <h1>Termination rights and policy</h1>
            <p>
              These terms and conditions shall remain valid and active until
              terminated or cancelled by StockAnts for any or the reasons
              mentioned below but not limited to:
            </p>

            <ul>
              <li>Breach of agreement by the user.</li>
              <li>
                Unauthorised access granted to an unregistered person or
                unauthorised use by you.
              </li>
              <li>You choose to discontinue your account with the platform.</li>
              <li>
                If you attempt to transfer any of the rights granted to you
                under these terms to a person unregistered on the platform.
              </li>
            </ul>

            <p>
              StockAnts can blacklist you or block access to the platform if it
              is of the opinion that you have infringed, breached, violated,
              abused or unethically manipulated these terms of use or acted
              unethically on any occasion.
            </p>
          </div>
          <div class="special-sec">
            Privacy

            <p>
              The user represents that he is aware that in the process of using
              the website or parts of it or subscribing to any services offered
              by StockAnts, StockAnts may obtain information relating to the
              user, including that of a confidential nature.
            </p>
            <p>
              StockAnts may for the purpose of rendering its services may
              collect personal information such as including email address or
              other contact information, PAN, signature and photograph, Bank
              account or other payment instrument details; or any other detail
              for providing services. StockAnts can use the information provided
              by you at its own discretion, while disseminating it for any other
              purpose as StockAnts deems appropriate.
            </p>
            <p>
              This information provided by the Users will be used by StockAnts
              for its internal purposes as well as external purposes. The User
              agrees to permit StockAnts to share data to the third parties to
              provide services to the User. Notwithstanding anything contained
              above, StockAnts reserves the right to disclose personal
              information where it believes in good faith that such disclosure
              is required by law, to perform necessary credit checks or to
              protect StockAnts' rights or property or for other bonafide uses.
              The user agrees and warrants that all information that StockAnts
              may possess or may obtain pursuant to the use of website and
              services has been possessed or obtained with the permission of the
              user.
            </p>

            <p>
              Click here to read our
              <a @click="$router.push('/privacy&policies')">Privacy Policy.</a>
            </p>
          </div>

          <div class="special-sec">
            <h1>Disclaimer of warranties:</h1>

            <p>
              StockAnts is a platform for investors and Experts and provides
              technology solutions and related back-end infrastructure. The User
              warrants that he/she/it shall obtain independent investment advice
              before making any Investment based on the recommendation or price
              estimates received on Website or mobile app.
            </p>
            <p>
              StockAnts shall not be responsible (directly or indirectly) for
              use or otherwise of Service by a User, including a User who is a
              citizen or resident or located in any locality, state, country or
              other jurisdiction outside India specifically a resident of the
              United States of America, Canada or the European Union countries
              and we hereby expressly disclaim any implied warranties imputed by
              the laws of any other jurisdiction.
            </p>
            <p>
              StockAnts shall also not be liable for errors, omissions or
              typographical errors, disruption delay, interruption, failure,
              deletion or defect of/in the services provided by it.
            </p>
            <p>
              StockAnts does not warrant accuracy of any feed from the stock
              exchanges/ currency/commodities exchanges or any other third
              party.
            </p>
            <p>
              Where StockAnts offers to send alerts to the user through SMS,
              StockAnts shall not be liable to pay or bear any cost, charges,
              fee charged by a service provider to the subscriber for receipt of
              such SMS. StockAnts may at any time without notice withdraw the
              facility of sending SMS alerts to the subscribers. In case any
              subscriber does not want to receive SMS alerts from StockAnts,
              he/she may unsubscribe or send a written intimation to StockAnts
              on the same.
            </p>
            <p>
              The website assumes no responsibility for damage to computers or
              software of the user from corrupting code or data that is
              inadvertently passed to the user’s computer. Again, the user views
              and interacts with this website, or banners or pop-ups or
              advertising displayed thereon, at his own risk.
            </p>
          </div>
          <div class="special-sec">
            <h1>Disclaimer for Performance Calculation</h1>

            <p>
              Calculation of performance data is based on assumptions integral
              to the model which may or may not be testable and are therefore
              subject to losses. Actual performance may differ from performance
              calculated on platform. Returns calculated on platform do not
              represent actual returns and should not be interpreted as an
              indication of such. StockAnts will not be liable or responsible
              for any loss or liability incurred by the user on account of any
              decisions taken on the basis of back testing results.
            </p>
          </div>
          <div class="special-sec">
            <h1>Posting comments</h1>

            <p>
              The views, opinions and comments posted are yours, and are not
              endorsed by StockAnts.
            </p>
            <p>
              You shall be solely responsible for the comment(s) posted on
              StockAnts. Comments posted on StockAnts may be moderated and
              StockAnts reserves the right to edit, modify, delete, reject, or
              otherwise remove any views, opinions and comments posted or part
              thereof without notice.
            </p>
            <p>
              You shall ensure that your comment is not inflammatory, abusive,
              derogatory, defamatory &/or obscene, or contain pornographic
              matter and/or does not constitute hate mail, or violate privacy of
              any person (s) or breach confidentiality or otherwise is illegal,
              immoral or contrary to public policy. Nor should it contain
              anything infringing copyright &/or intellectual property rights of
              any person(s).
            </p>
            <p>
              StockAnts does not guarantee the accuracy, integrity or quality of
              any content posted on StockAnts.
            </p>
            <p>
              You agree to not send, submit, post, or otherwise transmit,
              messages or material that contain software virus, that are
              designed to interrupt, destroy, and negatively affect in any
              manner whatsoever, any electronic equipment / software / coding in
              connection with the use of this website and mobile app.
            </p>
            <p>
              In the event that you breach any of the Terms and Conditions,
              StockAnts reserves the right to delete any material relating to
              the violations without notice. StockAnts also reserves the right
              to ban anyone who wilfully violates these Terms and Conditions.
              Inobservance of these terms and conditions may lead to an
              immediate warning, an infraction and deletion of the concerned
              post. Repeated offences shall lead to the user being permanently
              banned from StockAnts.
            </p>
          </div>
          <div class="special-sec">
            <h1>Terms and conditions applicable to the Experts:</h1>
            <ul>
              <li>
                The Experts will be liable and responsible for the compliance of
                applicable laws, acts, rules and regulations in order to provide
                recommendations on StockAnts.
              </li>
              <li>
                StockAnts reserves the right to discontinue, whether on a
                temporary or permanent basis, any of the features available on
                Website and mobile application.
              </li>
              <li>
                The Experts agree that the aggregated market estimate may not be
                accurate and StockAnts does not guarantee the accuracy of the
                same.
              </li>
              <li>
                StockAnts does not guarantee a specific number of users of your
                services.
              </li>
              <li>
                In case any Expert requests to delete the account, the same will
                be done as per the discretion of StockAnts. StockAnts also
                reserves the right to display the data and information on the
                Website and mobile app after the deletion of the account of an
                Expert.
              </li>
              <li>
                Experts who have not logged in to the Website for a continuous
                period of 6 months will be considered as “inactive” and such
                accounts will be either made inactive or deleted as per the
                discretion of StockAnts.
              </li>
            </ul>

            <hr>

<h3 style="color: #322e79;" >📜 ExpertBuzz – Code of Conduct</h3>
<p>The ExpertBuzz Code of Conduct is based on three key pillars that define the essence of our community:</p>
<ul>
  <li>Platform Participation</li>
  <li>Professional Expert Conduct</li>
  <li>Content Moderation & Governance</li>
</ul>

<h4 style="color: #322e79;">PLATFORM PARTICIPATION</h4>
<p>
  ExpertBuzz is a curated, one-way content space powered by SEBI-registered experts, designed to deliver credible market insights to a wide investor audience. StockAnts believes in empowering experts with a platform rooted in trust, responsibility, and knowledge sharing.
</p>
<p>
  By participating in ExpertBuzz, all experts acknowledge their role as thought leaders and contributors to an ethical, educational, and value-driven investment ecosystem.
</p>

<h4 style="color: #322e79;">PROFESSIONAL EXPERT CONDUCT</h4>
<p>As contributors to ExpertBuzz, SEBI-registered Experts are expected to maintain the highest standards of integrity, responsibility, and professionalism.</p>
<p>Experts must refrain from the following:</p>
<ul>
  <li>🚫 Personal attacks, derogatory remarks, or inflammatory content</li>
  <li>🚫 Comments referencing race, religion, caste, gender, or political ideology</li>
  <li>🚫 Misleading, sensationalized, or unverified market claims</li>
  <li>🚫 Aggressive self-promotion or misrepresentation of services</li>
  <li>🚫 Offensive language, verbal threats, or use of ALL CAPS (considered shouting)</li>
  <li>🚫 Repetitive or irrelevant posts (spamming)</li>
  <li>🚫 Posting unauthorized commercial ads, third-party links, or phone numbers</li>
  <li>🚫 Sharing paid content without clear disclosure</li>
</ul>
<p>
  You may promote your services, webinars, or offerings only if they are relevant and transparently communicated to users, with no aggressive or misleading claims.
</p>

<h4 style="color: #322e79;">CONTENT MODERATION & PLATFORM RIGHTS</h4>
<p>To ensure ExpertBuzz remains trustworthy and impactful:</p>
<ul>
  <li> StockAnts reserves the right to review, moderate, or remove any post that violates this code or affects platform quality</li>
  <li> Experts may temporarily lose publishing privileges for violating rules</li>
  <li> Repeated violations may lead to permanent revocation of access</li>
  <li> Only one video will be featured at a time – selection is subject to platform/editorial decision</li>
</ul>
<p>
  All decisions by the StockAnts Moderation Team are final and binding. ExpertBuzz is a growing ecosystem, and StockAnts may update this Code of Conduct at any time to reflect evolving best practices.
</p>

<h4 style="color: #322e79;">🛡️ Your Contribution Matters</h4>
<p>
  By maintaining a high standard of conduct, you help build a credible, engaging, and safe financial knowledge ecosystem for investors across India and beyond.
</p>
<p>
  Let’s make ExpertBuzz a trusted destination for meaningful market insights.
</p>
          </div>

         <div class="special-sec">
  <h1>StockAnts Chat</h1>
  <p>
    Welcome to StockAnts, where SEBI-registered experts provide insights and guidance to retail investors. By participating in chats with SEBI Experts on our platform, you agree to the following terms and conditions. Please read them carefully.
  </p>

  <ul>
    <li>
      <strong>Eligibility</strong><br>
      Only SEBI-registered experts are permitted to offer advice or guidance on StockAnts.
    </li>

    <li>
      <strong>Nature of Interaction</strong><br>
      The interaction between SEBI Experts and retail users is purely informational and educational. The advice provided does not constitute personalized financial, investment, or trading advice.<br>
      SEBI Experts are required to adhere to SEBI regulations and guidelines while interacting with users.
    </li>

    <li>
      <strong>No Investment Advice</strong><br>
      All content provided by SEBI Experts on StockAnts, including chats, is for general informational purposes only and should not be construed as investment advice.<br>
      Users should perform their own due diligence and consult with their financial advisor before making any investment decisions.
    </li>

    <li>
      <strong>Confidentiality and Privacy</strong><br>
      SEBI Experts and retail users must maintain confidentiality regarding personal financial information. StockAnts will not be held liable for any breach of confidentiality by either party.<br>
      All interactions on the platform are subject to StockAnts' Privacy Policy, which governs the collection and use of user data.
    </li>

    <li>
      <strong>Conduct and Compliance</strong><br>
      SEBI Experts must comply with all relevant SEBI regulations and guidelines while interacting with users.<br>
      Any form of misleading, manipulative, or fraudulent behavior is strictly prohibited. SEBI Experts who engage in such behavior will be subject to suspension or termination of their accounts.<br>
      Users must conduct themselves respectfully and avoid any inappropriate or abusive language during interactions.
    </li>

    <li>
      <strong>Limitations of Liability</strong><br>
      StockAnts, its affiliates, and the SEBI Experts are not liable for any direct, indirect, incidental, or consequential damages resulting from the use of the platform or reliance on the information provided.<br>
      StockAnts is not responsible for any trading or investment decisions made by users based on the information provided during chats.
    </li>

    <li>
      <strong>Disclaimers</strong><br>
      StockAnts does not endorse any specific investment strategy, recommendation, or advice provided by SEBI Experts.<br>
      The accuracy, completeness, or timeliness of the information provided by SEBI Experts is not guaranteed by StockAnts.
    </li>

    <li>
      <strong>Termination of Service</strong><br>
      StockAnts reserves the right to terminate or suspend access to the chat service at its discretion, including but not limited to, violations of these terms and conditions or applicable laws.<br>
      SEBI Experts found to be in violation of SEBI regulations or StockAnts' policies may be permanently banned from the platform.
    </li>

    <li>
      <strong>Amendments</strong><br>
      StockAnts reserves the right to update or modify these terms and conditions at any time. Users and SEBI Experts will be notified of any significant changes.
    </li>

    <li>
      <h4 style="color: #322e79;">🛡️ Your Contribution Matters</h4>
      <p>
        By maintaining a high standard of conduct, you help build a credible, engaging, and safe financial knowledge ecosystem for investors across India and beyond.
      </p>
      <p>
        Let’s make ExpertBuzz a trusted destination for meaningful market insights.
      </p>
    </li>

    <li>
      <strong>Governing Law</strong><br>
      These terms and conditions are governed by and construed in accordance with the laws of [Jurisdiction]. Any disputes arising out of or related to these terms shall be subject to the exclusive jurisdiction of the courts in [Jurisdiction].
    </li>

   
  </ul>
</div>

<div class="special-sec">
  <h1>User Consent Statement</h1>
  <p>
   By proceeding, I agree to view the market insights, recommedations & strategies of stock, index, options, or ETF recommendations published by SEBI-registered Research Analysts on the StockAnts platform. This data is shared solely for transparency and educational purposes. It is not a guarantee, promise, or prediction of future outcomes and does not represent investment advice or assurance of performance in any manner whatsoever.
  </p>

  <ul>
    <li>
      <strong>Important Disclosures</strong><br>
      I acknowledge that all forms of investing are subject to market risks and outcomes may vary based on various factors beyond control. The performance data shown does not ensure future success and should be interpreted with discretion. I am voluntarily accessing this information for informational and educational use only. I understand that this content is not a promotional tool and does not constitute personalized investment advice. Any investment decisions I make are solely my responsibility.
    </li>
  </ul>
</div>
        </el-col>

        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsAndconditionComponent",
};
</script>

<style lang="scss" scoped>
.terms-condition-component {
  .section-2 {
    .special-sec {
      margin: 60px 0;
    }
    h1 {
      font-size: 1.6rem;
      font-weight: 600;
      color: #25246a;
    }
    p {
      font-size: 0.9rem;
      color: #6d6a6a;
    }
    ul {
      list-style: none;
      li {
        font-size: 0.9rem;
        margin: 10px 0;
        color: #6d6a6a;
      }
      li::before {
        content: "\2022";
        color: #322e79;
        font-weight: bold;
        width: 1em;
        margin-left: -1em;
        font-size: 45px;
        position: relative;
        margin-right: 25px;
        top: 7px;
      }
    }
  }

  @media screen and (max-width: 876px) {
    .section-2 {
      padding: 0 70px;
    }
  }
  @media screen and (max-width: 600px) {
    .section-2 {
      padding: 0 35px;
    }
  }
  @media screen and (max-width: 450px) {
    .section-2 {
      padding: 0 20px;
    }
  }
}
</style>
